import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import KAISTHeader from './KAISTHeader';
import KAISTSidebar from './KAISTSidebar';
import KAISTDashboard from '../pages/KAISTDashboard';
import KAISTTransactions from '../pages/KAISTTransactions';
import KAISTMyBlocks from '../pages/KAISTMyBlocks';
import KAISTMyInfo from '../pages/KAISTMyInfo';
import PartnerIntegrationPrototype from '../pages/PartnerIntegrationPrototype';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

interface KAISTMainProps {
  user: UserInfo;
  onLogout: () => void;
}

function KAISTMain({ user, onLogout }: KAISTMainProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const isIntegrationPrototype = location.pathname === '/integration-prototype';

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <KAISTHeader 
        user={user}
        onMenuClick={toggleSidebar} 
        onLogout={onLogout} 
      />
      <KAISTSidebar 
        open={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />
      <Container 
        component="main" 
        maxWidth={isIntegrationPrototype ? false : 'xl'}
        disableGutters={isIntegrationPrototype}
        sx={{ 
          flexGrow: 1, 
          padding: '24px',
          marginTop: 9,
          marginLeft: sidebarOpen ? 15 : 8,
          marginRight: 8,
          transition: 'margin-left 0.3s ease'
        }}
      >
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<KAISTDashboard user={user} />} />
          <Route path="/transactions" element={<KAISTTransactions user={user} />} />
          <Route path="/blocks" element={<KAISTMyBlocks user={user} />} />
          <Route path="/my-blocks" element={<Navigate to="/blocks" replace />} />
          <Route path="/integration-prototype" element={<PartnerIntegrationPrototype partner="KAIST" user={user} />} />
          <Route path="/my-info" element={<KAISTMyInfo user={user} />} />
          <Route path="/info" element={<Navigate to="/my-info" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Container>
    </Box>
  );
}

export default KAISTMain;
